<script setup>
    import { ref, computed } from 'vue'
    import { useRouter, RouterLink } from 'vue-router'
    import SNBAdmin from '../../../../../layouts/nav/SNBAdmin.vue'
    import insightsFAQService from "../../../../user/services/insights/insightsFAQService";
    import {usePageLoadingStore} from "../../../../../stores/pageLoading";
    import { useAlertStore } from '../../../../../stores/alertStore';
    
    const router = useRouter();
    const loadingStore = usePageLoadingStore()
    const { $alert } = useAlertStore();

    const input = ref({
        boardGroup: '21',
        title: '',
        content: '',
    })

    const inputError = ref({
        title: '',
        content: '',
    })

    const onSelectBoardGroup = (option) => {
        input.value.boardGroup = option.value;
    }

    const create = () => {
        const { boardGroup, title, content } = input.value;
        let isInvalid = false;

        inputError.value = {
            title: '',
            content: '',
        };

        if(!title) {
            inputError.value.title = '자주하는 질문을 입력하세요.';
            isInvalid = true;
        }
        if(!content) {
            inputError.value.content = '내용을 입력하세요.';
            isInvalid = true;
        }


        if(!isInvalid) {
            let paramObj = {
                boardGroup,
                title,
                content,
            }

            loadingStore.loading = true;
            insightsFAQService.createFAQ(paramObj)
                .then( (res) => {
                    loadingStore.loading = false;
                    if(res.data.code.toLowerCase() === 'success') {
                        const result = res.data.result;
                        goBack()
                    } else {
                        $alert.error("등록을 실패하였습니다.");
                    }
                }).catch( (res) =>  {
                loadingStore.loading = false;
                // console.log(res);
                $alert.error("등록을 실패하였습니다.");
            });
        }
    }

    const goBack = () => {
        router.push({name:'CSFAQList'})
    }
</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>FAQ 작성</h3>
        </div>
        <div class="table-form">
            <p>모든 정보는 필수입력 사항입니다.</p>
            <table class="vertical">
                <colgroup>
                    <col width="200px" />
                    <col />
                </colgroup>
                <tr>
                    <th>구분</th>
                    <td>
                        <KSASelect :options="$gb['BOARD_GROUP_FAQ']" class="select" @selectOption="onSelectBoardGroup"/>
                    </td>
                </tr>
                <tr>
                    <th>자주하는 질문</th>
                    <td>
                        <KSAInput v-model="input.title" :msg="inputError.title" placeholder="자주하는 질문을 입력하세요."/>
                    </td>
                </tr>
                <tr>
                    <th>답변</th>
                    <td>
                        <KSACKEditor ref="editorRef" v-model="input.content"/>
                        <div>
                            <small style="color:#E71414;">{{ inputError.answer }}</small>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div class="btn-wrap space-between">
            <KSASecondaryButton class="gray_button" text="취소" @click="goBack" />
            <KSAPrimaryButton text="등록" @click="create" />
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import "../../../../../assets/scss/theme";

    .textarea-box {
        height: 300px;
    }

</style>